export { default } from './VisuallyHiddenText';
